"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CostModel1ToJSON = exports.CostModel1FromJSONTyped = exports.CostModel1FromJSON = exports.CostModel1 = void 0;
/**
 * Method used to determine how advertisers are charged for their ad campaigns.
 * - "CPM": Cost Per Thousand Impressions.
 * - "CPCL": Cost Per Thousand Listens.
 *
 * @export
 */
exports.CostModel1 = {
    Cpd: 'CPD',
    Cpm: 'CPM',
    Cpcl: 'CPCL',
    Fcpm: 'FCPM',
    Cpr: 'CPR'
};
function CostModel1FromJSON(json) {
    return CostModel1FromJSONTyped(json, false);
}
exports.CostModel1FromJSON = CostModel1FromJSON;
function CostModel1FromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CostModel1FromJSONTyped = CostModel1FromJSONTyped;
function CostModel1ToJSON(value) {
    return value;
}
exports.CostModel1ToJSON = CostModel1ToJSON;
